import React, { useState } from 'react';
import { FormattedMessage } from 'react-intl';

import { Tabs, TabList, Tab, TabPanel } from 'ui-components/components/tabs';

import { useEnableLossPrevention } from '../../../feature-flags/hooks/use-enable-loss-prevention';

import { BlacklistManagement } from './blacklist-management';
import { FeatureManagement } from './feature-management';
import styles from './loss-prevention.module.less';
import { messages } from './messages';

const FEATURE_MANAGEMENT_TAB_INDEX = 0;

export const LossPrevention = () => {
  const isLossPreventionEnabled = useEnableLossPrevention();
  const [selectedTabIndex, setSelectedTabIndex] = useState(FEATURE_MANAGEMENT_TAB_INDEX);

  if (!isLossPreventionEnabled) {
    return null;
  }

  return (
    <div className={styles.page}>
      <Tabs className={styles.tabs} onSelectedTabIndexChange={setSelectedTabIndex} selectedTabIndex={selectedTabIndex}>
        <TabList className={styles['tab-list']}>
          <Tab>
            <FormattedMessage {...messages.featureManagementTab} />
          </Tab>
          <Tab>
            <FormattedMessage {...messages.blacklistManagementTab} />
          </Tab>
        </TabList>

        <TabPanel className={styles['tab-panel']}>
          <FeatureManagement />
        </TabPanel>

        <TabPanel className={styles['tab-panel']}>
          <BlacklistManagement />
        </TabPanel>
      </Tabs>
    </div>
  );
};
